// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"a0ef9d41","321":"6336a47c","417":"38f05b74","453":"83744d21","559":"2201bc93","629":"20e1f955","795":"f8614b0d"}[chunkId] + ".chunk.js";
};